import { createBrowserRouter, Navigate } from 'react-router-dom';
import Dashboard from '../components/Dashboard/Dashboard';
import InitialTest from '../components/InitialTest/InitialTest';
import CorrectionMode from '../components/CorrectionMode/CorrectionMode';
import ConstructionMode from '../components/ConstructionMode/ConstructionMode';
import StoryMode from '../components/StoryMode/StoryMode';
import AdaptiveMode from '../components/AdaptiveMode/AdaptiveMode';
import Layout from '../components/Layout/Layout';
import Login from '../components/Login/Login';
import Register from '../components/SignUp/Signup';
import { useUser } from '../context/UserContext';
import ExamMode from '../components/ExamMode/ExamMode';
import WordCompletionMode from '../components/SpellingModes/WordCompletionMode';
import AudioSpellingMode from '../components/SpellingModes/AudioSpellingMode';
import AnagramChallengeMode from '../components/SpellingModes/AnagramChallengeMode';
import DefinitionSpellingMode from '../components/SpellingModes/DefinitionSpellingMode';
import SpellingBeeMode from '../components/SpellingModes/SpellingBeeMode';
import StorySpellingMode from '../components/SpellingModes/StorySpellingMode';
import WritingTest from '../pages/WritingTest';
import WritingResults from '../pages/WritingResults';
import ResultsPage from '../components/ResultsPage/ResultsPage';
import TestConfig from '../components/modals/TestConfig';
import ProfileCompletion from '../components/ProfileCompletion/ProfileCompletion';
import Flashcards from '../components/VocabModes/Flashcards';
import SentenceUsage from '../components/VocabModes/SentenceUsage';
import WordAssociation from '../components/VocabModes/WordAssociation';
import GuessTheMeaning from '../components/VocabModes/GuessTheMeaning';

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const { userProgress, loading, error } = useUser();
  
  if (loading) {
    return <div>Loading...</div>;
  }

  // if (!token) {
  //   return <Navigate to="/login" replace />;
  // }

  if (userProgress?.isProfileComplete === false && !window.location.pathname.includes('/complete-profile')) {
    return <Navigate to="/complete-profile" replace />;
  }

  if (!userProgress?.hasCompletedInitialTest && !window.location.pathname.includes('/initial-test')) {
    return <Navigate to="/initial-test" replace />;
  }

  return children;
};

export const router = createBrowserRouter([
  {
    path: '/',
    element: <Layout />,
    children: [
      {
        path: '/',
        element: (
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        ),
      },
      {
        path: '/initial-test',
        element: (
          <PrivateRoute>
            <InitialTest />
          </PrivateRoute>
        ),
      },
      {
        path: '/mode/correction',
        element: (
          <PrivateRoute>
            <CorrectionMode />
          </PrivateRoute>
        ),
      },
      {
        path: '/mode/construction',
        element: (
          <PrivateRoute>
            <ConstructionMode />
          </PrivateRoute>
        ),
      },
      {
        path: '/mode/story',
        element: (
          <PrivateRoute>
            <StoryMode />
          </PrivateRoute>
        ),
      },
      {
        path: '/mode/adaptive',
        element: (
          <PrivateRoute>
            <AdaptiveMode />
          </PrivateRoute>
        ),
      },
      {
        path: '/mode/exam',
        element: (
          <PrivateRoute>
            <ExamMode />
          </PrivateRoute>
        ),
      },
      {
        path: '/mode/word_completion',
        element: (
          <PrivateRoute>
            <WordCompletionMode />
          </PrivateRoute>
        ),
      },
      {
        path: '/mode/audio_spelling',
        element: (
          <PrivateRoute>
            <AudioSpellingMode />
          </PrivateRoute>
        ),
      },
      {
        path: '/mode/anagram_challenge',
        element: (
          <PrivateRoute>
            <AnagramChallengeMode />
          </PrivateRoute>
        ),
      },
      {
        path: '/mode/definition_spelling',
        element: (
          <PrivateRoute>
            <DefinitionSpellingMode />
          </PrivateRoute>
        ),
      },
      {
        path: '/mode/spelling_bee',
        element: (
          <PrivateRoute>
            <SpellingBeeMode />
          </PrivateRoute>
        ),
      },
      {
        path: '/mode/story_spelling',
        element: (
          <PrivateRoute>
            <StorySpellingMode />
          </PrivateRoute>
        ),
      },
      {
        path: '/writing-test/:id',
        element: (
          <PrivateRoute>
            <WritingTest />
          </PrivateRoute>
        ),
      },
      {
        path: '/writing-results/:id',
        element: (
          <PrivateRoute>
            <WritingResults />
          </PrivateRoute>
        ),
      },
      {
        path: '/results/',
        element: (
          <PrivateRoute>
            <ResultsPage />
          </PrivateRoute>
        ),
      },
      // {
      //   path: '/login',
      //   element: <Login />,
      // },
      // {
      //   path: '/register',
      //   element: <Register />,
      // },
      {
        path: '/writely/mode/:id',
        element: (
          <PrivateRoute>
            <TestConfig />
          </PrivateRoute>
        ),
      },
      {
        path: '/complete-profile',
        element: (
          <ProfileCompletion />
        ),
      },
      {
        path: '/vocabulary/learn_practice/flashcards',
        element: (
          <PrivateRoute>
            <Flashcards />
          </PrivateRoute>
        ),
      },
      {
        path: '/vocabulary/learn_practice/sentence_usage',
        element: (
          <PrivateRoute>
            <SentenceUsage />
          </PrivateRoute>
        ),  
      },
      {
        path: '/vocabulary/learn_practice/word_association',
        element: (
          <PrivateRoute>
            <WordAssociation />
          </PrivateRoute>
        ),
      },
      {
        path: '/vocabulary/guess-meaning',
        element: (
          <PrivateRoute>
            <GuessTheMeaning />
          </PrivateRoute>
        ),
      },
      {
        path: '*',
        element: <Navigate to="/" replace />
      }
    ],
  },
]); 